jQuery(document).ready(function($) {
    // Open the first accordion by default
    var firstItem = $('.product-accordion-item:first-child');
    firstItem.addClass('active');
    firstItem.find('.product-accordion-content').show();
    // The line that changed the icon to '−' has been removed.

    // Handle click events
    $('.product-accordion-title').on('click', function() {
        var clickedItem = $(this).parent('.product-accordion-item');

        // If the clicked item is not already active...
        if (!clickedItem.hasClass('active')) {
            // ...close all other items
            $('.product-accordion-item').removeClass('active');
            $('.product-accordion-content').slideUp(300);
            // The line that reset all icons to '+' has been removed.

            // ...and open the clicked item
            clickedItem.addClass('active');
            clickedItem.find('.product-accordion-content').slideDown(300);
            // The line that changed the new icon to '−' has been removed.
        } else {
            // Otherwise, if it is already active, just close it
            clickedItem.removeClass('active');
            clickedItem.find('.product-accordion-content').slideUp(300);
            // The line that changed the icon to '+' has been removed.
        }
    });
});

// Quantity Buttons

// --- Make the new quantity buttons work ---
jQuery(document).on('click', '.plus, .minus', function() {
    var qty = jQuery(this).closest('.quantity').find('.qty');
    var val = parseFloat(qty.val());
    var max = parseFloat(qty.attr('max'));
    var min = parseFloat(qty.attr('min'));
    var step = parseFloat(qty.attr('step'));

    if (jQuery(this).is('.plus')) {
        if (max && (val >= max)) {
            qty.val(max);
        } else {
            qty.val(val + step);
        }
    } else {
        if (min && (val <= min)) {
            qty.val(min);
        } else if (val > 0) {
            qty.val(val - step);
        }
    }
    // Trigger change event for WooCommerce
    qty.trigger('change');
});


// --- FINAL, SIMPLIFIED JAVASCRIPT for Custom Cart Counter ---

jQuery(function($) {

    /**
     * This is our core display function. It creates/updates our custom counter.
     */
    function create_and_update_custom_counter(count) {
        // Target the link from our custom shortcode.
        var cart_container = $('.uc-custom-cart-link');
        if (cart_container.length === 0) {
            // If the container can't be found, do nothing.
            return;
        }

        // Find OUR custom counter span. If it doesn't exist, create it.
        var custom_counter = cart_container.find('.uc-custom-cart-count');
        if (custom_counter.length === 0) {
            cart_container.append('<span class="uc-custom-cart-count"></span>');
            custom_counter = cart_container.find('.uc-custom-cart-count');
        }

        // Update the text and visibility of our counter.
        if (count > 0) {
            custom_counter.text(count).show();
        } else {
            custom_counter.hide();
        }
    }

    /**
     * This is our reliable AJAX function to get the latest cart quantity from the server.
     */
    function get_correct_count_and_update() {
        // Ensure the PHP parameters are available before making the call.
        if (typeof uc_cart_params !== 'undefined') {
            $.post(uc_cart_params.ajax_url, { action: 'get_cart_total_quantity' }, function(response) {
                if (response.success) {
                    create_and_update_custom_counter(response.data.total_quantity);
                }
            });
        }
    }

    // --- SCRIPT INITIALIZATION ---

    // 1. INSTANT UPDATE ON PAGE LOAD
    // This uses the data passed directly from PHP for a zero-delay load.
    if (typeof uc_cart_params !== 'undefined') {
        create_and_update_custom_counter(uc_cart_params.initial_cart_count);
    }

    // 2. LISTEN FOR FASTER EVENTS FOR SUBSEQUENT UPDATES
    // These events fire sooner than 'wc_fragments_refreshed'.
    // When they fire, we call our reliable AJAX function to get the true count.
    $(document.body).on('added_to_cart removed_from_cart', function() {
        get_correct_count_and_update();
    });

});